var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8093 14.7235C10.6707 17.166 6.13194 16.9456 3.24689 14.0606C0.122912 10.9366 0.122653 5.87109 3.24689 2.74686C6.37112 -0.377378 11.4366 -0.377119 14.5606 2.74686C17.4456 5.63191 17.666 10.1707 15.2235 13.3093L18.8032 16.889C18.9911 17.0768 19.0892 17.3212 19.0955 17.5662C19.1033 17.8319 19.0061 18.1004 18.8032 18.3032C18.4127 18.6937 17.7799 18.694 17.389 18.3032L13.8093 14.7235ZM13.1464 4.16107C15.4901 6.50474 15.4895 10.3032 13.1464 12.6464C10.8032 14.9895 7.00477 14.99 4.6611 12.6464C2.31743 10.3027 2.31795 6.50422 4.6611 4.16107C7.00426 1.81792 10.8027 1.8174 13.1464 4.16107Z",
    fill: "#DB4C40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.0dc55da3ba35dc1e1ffb9709495f48a0.svg";
export { ForwardRef as ReactComponent };